export const mediaAnimationProps = (visible?: boolean) => ({
  delay: 300,
  from: { transform: 'translateY(30%)', opacity: 0 },
  to: { transform: 'translateY(0)', opacity: 1 },
  reverse: !visible,
});
